import 'core-js/modules/es6.reflect.construct';
import _classCallCheck from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js';
import _createClass from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js';
import _inherits from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js';
import _possibleConstructorReturn from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js';
import _getPrototypeOf from '/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js';
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module media-embed/mediaembedui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { createDropdown } from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import MediaFormView from './ui/mediaformview';
import MediaEmbedEditing from './mediaembedediting';
import mediaIcon from '../theme/icons/media.svg';
/**
 * The media embed UI plugin.
 *
 * @extends module:core/plugin~Plugin
 */
var MediaEmbedUI = /*#__PURE__*/
function (_Plugin) {
    _inherits(MediaEmbedUI, _Plugin);
    var _super = _createSuper(MediaEmbedUI);
    function MediaEmbedUI() {
        _classCallCheck(this, MediaEmbedUI);
        return _super.apply(this, arguments);
    }
    _createClass(MediaEmbedUI, [
        {
            key: 'init',
            value: /**
     * @inheritDoc
     */
            function init() {
                var _this = this;
                var editor = this.editor;
                var command = editor.commands.get('mediaEmbed');
                var registry = editor.plugins.get(MediaEmbedEditing).registry;
                /**
       * The form view displayed inside the drop-down.
       *
       * @member {module:media-embed/ui/mediaformview~MediaFormView}
       */
                this.form = new MediaFormView(getFormValidators(editor.t, registry), editor.locale);
                // Setup `imageUpload` button.
                editor.ui.componentFactory.add('mediaEmbed', function (locale) {
                    var dropdown = createDropdown(locale);
                    _this._setUpDropdown(dropdown, _this.form, command, editor);
                    _this._setUpForm(_this.form, dropdown, command);
                    return dropdown;
                });
            }
        },
        {
            key: '_setUpDropdown',
            value: function _setUpDropdown(dropdown, form, command) {
                var editor = this.editor;
                var t = editor.t;
                var button = dropdown.buttonView;
                dropdown.bind('isEnabled').to(command);
                dropdown.panelView.children.add(form);
                button.set({
                    label: t('Insert media'),
                    icon: mediaIcon,
                    tooltip: true
                });
                // Note: Use the low priority to make sure the following listener starts working after the
                // default action of the drop-down is executed (i.e. the panel showed up). Otherwise, the
                // invisible form/input cannot be focused/selected.
                button.on('open', function () {
                    // Make sure that each time the panel shows up, the URL field remains in sync with the value of
                    // the command. If the user typed in the input, then canceled (`urlInputView#value` stays
                    // unaltered) and re-opened it without changing the value of the media command (e.g. because they
                    // didn't change the selection), they would see the old value instead of the actual value of the
                    // command.
                    form.url = command.value || '';
                    form.urlInputView.select();
                    form.focus();
                }, { priority: 'low' });
                dropdown.on('submit', function () {
                    if (form.isValid()) {
                        editor.execute('mediaEmbed', form.url);
                        closeUI();
                    }
                });
                dropdown.on('change:isOpen', function () {
                    return form.resetFormStatus();
                });
                dropdown.on('cancel', function () {
                    return closeUI();
                });
                function closeUI() {
                    editor.editing.view.focus();
                    dropdown.isOpen = false;
                }
            }
        },
        {
            key: '_setUpForm',
            value: function _setUpForm(form, dropdown, command) {
                form.delegate('submit', 'cancel').to(dropdown);
                form.urlInputView.bind('value').to(command, 'value');
                // Form elements should be read-only when corresponding commands are disabled.
                form.urlInputView.bind('isReadOnly').to(command, 'isEnabled', function (value) {
                    return !value;
                });
                form.saveButtonView.bind('isEnabled').to(command);
            }
        }
    ], [
        {
            key: 'requires',
            get: /**
     * @inheritDoc
     */
            function get() {
                return [MediaEmbedEditing];
            }    /**
     * @inheritDoc
     */
        },
        {
            key: 'pluginName',
            get: function get() {
                return 'MediaEmbedUI';
            }
        }
    ]);
    return MediaEmbedUI;
}(Plugin);
export {
    MediaEmbedUI as default
};
function getFormValidators(t, registry) {
    return [
        function (form) {
            if (!form.url.length) {
                return t('The URL must not be empty.');
            }
        },
        function (form) {
            if (!registry.hasMedia(form.url)) {
                return t('This media URL is not supported.');
            }
        }
    ];
}